const dataItem = {
    date: '',   // 日期
    singlePrice: '',    // 单价
    amount: '',    // 数量
    hasPay: 1, 
    tip: '', // 是否支付
}

export function getNewItem() {
    const item = JSON.parse(JSON.stringify(dataItem));
    item.date = getNewDate();
    return item;
}
export function getStorage() {
    return new Promise((res, rej) => {
        axios('/get').then(data => {
            if(data) {
                const list = JSON.parse(data);
                // if (window.localStorage.getItem('sortByName')) {
                    const hostName = JSON.parse(JSON.stringify(list))[0].name;
                    list.sort((item, item1) => {
                        if (item.name == hostName) {
                            return -1;
                        }
                        if (item1.name == hostName) {
                            return 1;
                        }
                        return item.name.localeCompare(item1.name, "zh")
                    });
                // }
                res(list);
            } else {
                res([]);
            }
        })
    })
    // const data = window.localStorage.getItem('data');
    // return data ? JSON.parse(data) : undefined;
}
export function setStorage(data) {
    return axios('/set', JSON.stringify(data));
    // window.localStorage.setItem('data', JSON.stringify(data));
}

export function upgradeItem(item) {
    return new Promise((resolve, rej) => {
        getStorage().then(res => {
            const data = res;
            const index = data.findIndex(ware => ware.id == item.id);
            index > -1 && (data[index] = item);
            setStorage(data).then(() => {
                resolve('success');
            });
        });
    })
}

export function addRootItem(item) {
    return new Promise((resolve, rej) => {
        !item.id && (item.id = new Date().getTime());
        getStorage().then(res => {
            const data = res;
            if(!data) { 
                setStorage([item]).then(() => {
                    resolve('success');
                });
            } else {
                data.push(item);
                setStorage(data).then(() => {
                    resolve('success');
                });
            }
        });
    })
}

function getNewDate() {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function axios(url, data) {
    return fetch('http://localhost:8080'+url, {
        body: data,
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
    }).then(res => res.json());
}